import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import MuiLink, { LinkProps as MuiLinkProps } from "@mui/material/Link";
import { ForwardedRef, forwardRef, ElementType } from "react";

type CustomLinkProps = {
  to?: RouterLinkProps["to"];
  href?: string;
  component?: ElementType;
};

type LinkProps = Omit<RouterLinkProps, "to"> &
  Omit<MuiLinkProps, "href" | "component"> &
  CustomLinkProps;

const Link = forwardRef(
  (props: LinkProps, ref: ForwardedRef<HTMLAnchorElement>) => {
    const { to, href, component, ...rest } = props;

    // For React Router navigation
    if (to) {
      return <MuiLink component={RouterLink} to={to} {...rest} ref={ref} />;
    }

    // For regular links or custom component rendering
    if (component) {
      return <MuiLink to={to} component={component} {...rest} ref={ref} />;
    }

    // Default case: regular anchor link
    return <MuiLink href={href} {...rest} ref={ref} />;
  },
);

Link.displayName = "Link";

export default Link;
